import { Component } from '@angular/core'

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet><ngx-preview></ngx-preview>'
})
export class AppComponent {
}
